(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["one-a-120ml-announcement"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-ro-announcement-sound]');
  if(!button)return;
  const video=button.closest('.ro-announcement__media').querySelector('video');
  const enable=video.muted||video.volume===0;
  if(enable){video.currentTime=0;video.volume=1;}
  video.muted=!enable;
  button.setAttribute('aria-pressed',String(enable));
  button.textContent=enable?'Ton ausschalten':'Mit Ton abspielen';
  if(enable)video.play().catch(function(){});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["one-a-faq-service"] && !Shopify.designMode) return;
  try {
    function initFragranceFaq(){
document.querySelectorAll('[data-faq-service]').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const search=root.querySelector('[data-faq-search]');
const items=[...root.querySelectorAll('[data-faq-item]')];
const buttons=[...root.querySelectorAll('[data-faq-category]')];
const normalize=text=>text.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss');
let category='all';
function update(){
const words=normalize(search.value.trim()).split(/\s+/).filter(Boolean);
let count=0;
items.forEach(item=>{
const text=normalize(item.textContent);
const visible=(category==='all'||item.dataset.category===category)&&words.every(word=>text.includes(word));
item.hidden=!visible;
if(visible){count++;if(words.length)item.open=true;}
});
buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.faqCategory===category)));
const active=buttons.find(button=>button.dataset.faqCategory===category);
root.querySelector('[data-faq-heading]').textContent=words.length?'Suchergebnisse':active.textContent.replace('→','').trim();
root.querySelector('[data-faq-count]').textContent=count+(count===1?' Frage':' Fragen');
root.querySelector('[data-faq-empty]').hidden=count!==0;
}
buttons.forEach(button=>button.addEventListener('click',()=>{
category=button.dataset.faqCategory;search.value='';items.forEach(item=>item.open=false);
const first=items.find(item=>category==='all'||item.dataset.category===category);if(first)first.open=true;update();
}));
search.addEventListener('input',()=>{category='all';update();});
root.querySelector('[data-faq-reset]').addEventListener('click',()=>{category='all';search.value='';items.forEach((item,i)=>item.open=i===0);update();search.focus();});
update();
});
}
initFragranceFaq();
document.addEventListener('shopify:section:load',initFragranceFaq);
  } catch(e) { console.error(e); }
})();

})();
